import jQuery from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '@lottiefiles/lottie-player';
import * as PIXI from './_pixi_482.min.js';

// Older theme scripts and separately loaded scripts use these browser globals.
window.$ = window.jQuery = jQuery;
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.PIXI = PIXI;
gsap.registerPlugin(ScrollTrigger);
